import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { AnalyticsModule } from 'src/app/shared/analytics/analytics.module'
import { SvgModule } from 'src/app/shared/svg/svg.module'
import { CustomLinkModule } from '../custom-link/custom-link.directive.module'
import { ImageModule } from '../image/image.component.module'
import { LinkModule } from '../link/link.module'
import { FloCssClassSanitizePipeModule } from '../_pipes/css-class-sanitize/css-class-sanitize.pipe.module'
import { HeaderComponent } from './header.component'
import { BadgeModule } from '../badge/badge.module'

@NgModule({
  imports: [
    CommonModule,
    SvgModule,
    AnalyticsModule,
    CustomLinkModule,
    LinkModule,
    FloCssClassSanitizePipeModule,
    ImageModule,
    BadgeModule
  ],
  declarations: [HeaderComponent],
  exports: [HeaderComponent]
})
export class HeaderModule {}
